import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./leftnavbar.scss";
import { toggleSidebar } from "../../actions";
import { useLocation, useNavigate } from "react-router-dom";

import AgentLeftNavNew from "./AgentLeftNavNew";
import ClientLeftNav from "./ClientLeftNav";
import NewClientLeftNav from "./NewClientLeftNav";
import IndProfLeftNav from "./IndProfLeftNav";

const CLIENT_NAV_STORAGE_KEY = "client-nav-version"; // 'new' | 'old'

const routeMap = {
  new: new Map([
    ["/client-dashboard", "/new-client-dashboard"],
    ["/my-team", "/new-my-team"],
    ["/client-ordered-report", "/new-client-ordered-report"],
  ]),
  old: new Map([
    ["/new-client-dashboard", "/client-dashboard"],
    ["/new-my-team", "/my-team"],
    ["/new-client-ordered-report", "/client-ordered-report"],
  ]),
};

const LeftNavBar = () => {
  const type = useSelector((state) => state.auth.role);
  const isOpen = useSelector((state) => !state.sidebar.isOpen);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Default to 'new' client navbar
  const [clientNavVersion, setClientNavVersion] = useState(() => {
    const saved = localStorage.getItem(CLIENT_NAV_STORAGE_KEY);
    return saved === "old" ? "old" : "new";
  });

  // Persist preference
  useEffect(() => {
    try {
      localStorage.setItem(CLIENT_NAV_STORAGE_KEY, clientNavVersion);
    } catch {}
  }, [clientNavVersion]);

  // Auto-redirect client routes based on preference
  useEffect(() => {
    if (type !== "client") return;
    const map = routeMap[clientNavVersion];
    const next = map.get(location.pathname);
    if (next) {
      navigate(next, { replace: true });
    }
  }, [type, clientNavVersion, location.pathname, navigate]);

  // Toggle side nav on mobile view
  const closeOnMobile = () => {
    if (window.innerWidth <= 1200 && isOpen) {
      dispatch(toggleSidebar());
    }
  };

  const onSwitchVersion = useMemo(
    () => () => {
      setClientNavVersion((prev) => {
        const nextVersion = prev === "new" ? "old" : "new";
        if (type === "client") {
          // If there's an equivalent route, keep user on it; otherwise go to the dashboard
          const map = routeMap[nextVersion];
          const fallback =
            nextVersion === "new"
              ? "/new-client-dashboard"
              : "/client-dashboard";
          const nextPath = map.get(location.pathname) || fallback;
          navigate(nextPath);
        }
        return nextVersion;
      });
    },
    [navigate, type, location.pathname]
  );

  useEffect(() => {
    closeOnMobile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {type === "agent" || type === "realty_agent" ? (
        // <AgentLeftNav onClose={closeOnMobile} />
        <AgentLeftNavNew onClose={closeOnMobile} />
      ) : null}

      {type === "client" &&
        (clientNavVersion === "new" ? (
          <NewClientLeftNav
            onClose={closeOnMobile}
            onSwitchVersion={onSwitchVersion}
          />
        ) : (
          <ClientLeftNav
            onClose={closeOnMobile}
            onSwitchVersion={onSwitchVersion}
          />
        ))}

      {type === "ind_prof" && <IndProfLeftNav onClose={closeOnMobile} />}
    </>
  );
};

export default LeftNavBar;
